import classnames from 'classnames';
import React from 'react';
import './NavigationButton.scss';

export const NavigationButton: React.FC<{
    ariaLabel?: string;
    disabled?: boolean;
    icon: JSX.Element;
    className?: string;
    onClick: () => void;
}> = ({ disabled, icon, onClick, ariaLabel, children, className }) => (
    <button
        disabled={disabled}
        type="button"
        onClick={onClick}
        className={classnames(
            'eds-carousel-swiper-navigation-button eds-carousel-swiper-animation-fade-in',
            className,
        )}
        aria-label={ariaLabel}
    >
        <div className="eds-carousel-swiper-navigation-icon">{icon}</div>
        {children}
    </button>
);
